import {LocalizationStrings} from "../../../../../i18n/i18n-model";

export interface FindingsDescriptions {
  readonly prevailingRhythm: keyof LocalizationStrings;
  readonly averageHeartRate: keyof LocalizationStrings;
  readonly minimumHeartRate: keyof LocalizationStrings;
  readonly maximumHeartRate: keyof LocalizationStrings;
  readonly pausesOverThreshold: keyof LocalizationStrings;
  readonly ventricularBeats: keyof LocalizationStrings;
  readonly ventricularRuns?: keyof LocalizationStrings;
  readonly ventricularTachycardias: keyof LocalizationStrings;
  readonly slowVentricularRhythms: keyof LocalizationStrings;
  readonly commentVentricular: keyof LocalizationStrings;
  readonly atrialBeats: keyof LocalizationStrings;
  readonly supraventricularRuns?: keyof LocalizationStrings;
  readonly atrialTachycardias: keyof LocalizationStrings;
  readonly commentAtrial: keyof LocalizationStrings;
  readonly avConduction: keyof LocalizationStrings;
  readonly qrsWidth: keyof LocalizationStrings;
  readonly deltaWave: keyof LocalizationStrings;
  readonly qtTime: keyof LocalizationStrings;
  readonly stSegment: keyof LocalizationStrings;
  readonly symptomDiaryComment: keyof LocalizationStrings;
}

export const cardiologsFindingsDescriptions: FindingsDescriptions = {
  prevailingRhythm: "generator_description_prevailingRhythm_findingsGenerator",
  averageHeartRate: "generator_description_averageHeartRate_findingsGenerator",
  minimumHeartRate: "generator_description_minimumHeartRate_findingsGenerator",
  maximumHeartRate: "generator_description_maximumHeartRate_findingsGenerator",
  pausesOverThreshold: "generator_description_pausesOverThreshold_findingsGenerator",
  ventricularBeats: "generator_description_ventricularBeats_findingsGenerator",
  ventricularTachycardias: "generator_description_ventricularTachycardias_findingsGenerator",
  slowVentricularRhythms: "generator_description_slowVentricularRhythms_findingsGenerator",
  commentVentricular: "generator_description_commentVentricular_findingsGenerator",
  atrialBeats: "generator_description_atrialBeats_findingsGenerator",
  atrialTachycardias: "generator_description_atrialTachycardias_findingsGenerator",
  commentAtrial: "generator_description_commentAtrial_findingsGenerator",
  avConduction: "generator_description_avConduction_findingsGenerator",
  qrsWidth: "generator_description_qrsWidth_findingsGenerator",
  deltaWave: "generator_description_deltaWave_findingsGenerator",
  qtTime: "generator_description_qtTime_findingsGenerator",
  stSegment: "generator_description_stSegment_findingsGenerator",
  symptomDiaryComment: "generator_description_symptomDiaryComment_findingsGenerator",
};

export const casFindingsDescriptions: FindingsDescriptions = {
  prevailingRhythm: "generator_description_prevailingRhythm_findingsGenerator",
  averageHeartRate: "generator_description_averageHeartRate_findingsGenerator_cas",
  minimumHeartRate: "generator_description_minimumHeartRate_findingsGenerator_cas",
  maximumHeartRate: "generator_description_maximumHeartRate_findingsGenerator_cas",
  pausesOverThreshold: "generator_description_pausesOverThreshold_findingsGenerator_cas",
  ventricularBeats: "generator_description_ventricularBeats_findingsGenerator",
  ventricularRuns: "generator_description_ventricularRuns_findingsGenerator_cas",
  ventricularTachycardias: "generator_description_ventricularTachycardias_findingsGenerator_cas",
  slowVentricularRhythms: "generator_description_slowVentricularRhythms_findingsGenerator_cas",
  commentVentricular: "generator_description_commentVentricular_findingsGenerator",
  atrialBeats: "generator_description_atrialBeats_findingsGenerator",
  supraventricularRuns: "generator_description_supraventricularRuns_findingsGenerator_cas",
  atrialTachycardias: "generator_description_atrialTachycardias_findingsGenerator_cas",
  commentAtrial: "generator_description_commentAtrial_findingsGenerator",
  avConduction: "generator_description_avConduction_findingsGenerator_cas",
  qrsWidth: "generator_description_qrsWidth_findingsGenerator_cas",
  deltaWave: "generator_description_deltaWave_findingsGenerator",
  qtTime: "generator_description_qtTime_findingsGenerator_cas",
  stSegment: "generator_description_stSegment_findingsGenerator",
  symptomDiaryComment: "generator_description_symptomDiaryComment_findingsGenerator",
};
